var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('CommonHeader',{attrs:{"title":_vm.title,"is-back-btn":_vm.isBackBtn,"back-fn":_vm.backFn,"is-close-btn":_vm.isCloseBtn,"close-fn":_vm.closeFn}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }